<ng-container *ngIf="initialized">
  <form class="form" (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!userId" class="modal-title" id="exampleModalLabel">Add {{title}}</h5>
        <h5 *ngIf="userId" class="modal-title" id="exampleModalLabel">Edit {{title}}</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlInput1">Email</label>
              <input type="text" class="form-control" [readonly]="this.userId" formControlName="email" />
              <div class="invalid-message">
                <div>Email is required</div>
              </div>
            </div>
            <div class="form-group pl-8 pr-8" *ngIf="userExists">
              <p class="text-center">
                Hold the phone! It looks like a user with the email address <Strong>{{ formGroup.controls.email.value }}</Strong> already exists in {{settings.brand.brandName}}.
              </p>
              <div class="row">
                <div class="col-md-3">
                  <img class="img-fluid rounded-circle" [fallback]="'fetch-avatar?userId=' + existingUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ existingUser.id }}-avatar.png" />
                </div>
                <div class="col-md-9">
                  <div>{{existingUser.firstName}} {{existingUser.lastName}}, {{existingUser.credentials}}</div>
                  <button class="btn btn-sm btn-secondary mr-2" [promiseBtn]="submitComplete" (click)="linkExistingUser()" type="button">Link to Organization</button>
                </div>
              </div>
            </div>
            <div class="contextual-overlay-container">
              <div class="contextual-overlay-content" [ngClass]="{ show: !formGroup.controls.email.valid || userExists }">
                <div *ngIf="!formGroup.controls.email.valid">Start by entering the user's email</div>
              </div>
              <div class="contextual-overlay" [ngClass]="{ show: !formGroup.controls.email.valid || userExists }"></div>
              <div class="form-group">
                <label for="exampleFormControlInput1">First Name</label>
                <input type="text" class="form-control" [readonly]="this.userId" formControlName="firstName" />
                <div class="invalid-message">
                  <div>First Name is required</div>
                </div>
              </div>
              <div class="form-group">
                <label for="exampleFormControlInput1">Last Name</label>
                <input type="text" class="form-control" [readonly]="this.userId" formControlName="lastName" />
                <div class="invalid-message">
                  <div>Last Name is required</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-12">
            <button *ngIf="!userExists" class="btn btn-sm btn-secondary mr-2" [promiseBtn]="submitComplete" type="submit">
              <span *ngIf="!userId">Add User</span>
              <span *ngIf="userId">Update User</span>
            </button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
